export default function useCapitalize () {
  const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1)
  }
  return { capitalize }
}
